import { useEffect, useState } from "react";

/**
 * Renders the vendor logo from the API URL. Parent card shows the vendor name on error or missing URL.
 */
export default function MyVendorRotatingLogo({
  vendorName,
  logoUrl = null,
  className = "max-h-16 max-w-full w-auto object-contain",
  style,
  onExhausted,
}) {
  const [failed, setFailed] = useState(false);

  useEffect(() => {
    setFailed(false);
  }, [logoUrl]);

  if (!logoUrl || failed) {
    return null;
  }

  return (
    <img
      src={logoUrl}
      alt={`${vendorName} logo`}
      className={className}
      style={style}
      onError={() => {
        setFailed(true);
        onExhausted?.();
      }}
      loading="lazy"
    />
  );
}
